export const searchVersion1 = '1';
export const searchExtensionKey = 'company-hub-search';
export const searchExtensionType = 'com.atlassian.confluence.company-hub-search';
